<template>
    <div v-if="active" v-bind:style="{ backgroundColor: overLaycolor }"
         style="position:absolute; left:0; top:0; height:100%; width:100%; opacity:0.6;display: flex; align-items: center; justify-content:center;">
        <div class="n2-loader-default"></div>
    </div>
</template>
<script>
    export default {
        name: 'Loader',
        props: ['overlay_color', 'active'],
        computed: {
            overLaycolor: function () {
                return this.overlay_color ? this.overlay_color : '#f1f1f1';
            }
        }
    }
</script>

